"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoTileDidUpdateHandlerForHost = videoTileDidUpdateHandlerForHost;
exports.videoTileDidUpdateHandlerForMixer = videoTileDidUpdateHandlerForMixer;
exports.videoTileDidUpdateHandlerForSpeaker = videoTileDidUpdateHandlerForSpeaker;
var _underscore = _interopRequireDefault(require("underscore"));
var _logger = require("@studio/logger");
var _constants = require("../../../constants");
var _getAttendeePresenceFunc = require("../../../onPresenceChanged/getAttendeePresenceFunc");
var _subscribeToVolumeIndicator = require("../../../subscribeToVolumeIndicator");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var subscribeToVolumeIndicatorOnce = _underscore["default"].once(_subscribeToVolumeIndicator.subscribeToVolumeIndicator);
function videoTileDidUpdateHandlerForHost(dispatch, actions, meetingSession) {
  return function videoTileDidUpdateHandler(tileState) {
    var disconnectSource = actions.disconnectSource,
      setAttendeePresence = actions.setAttendeePresence,
      setAttendeeTile = actions.setAttendeeTile,
      setMeetingDirectorValue = actions.setMeetingDirectorValue,
      setAttendeeMuteStatus = actions.setAttendeeMuteStatus,
      setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity;

    // Ignore a tile without attendee ID and other attendee's tile.
    var attendeeId = tileState.boundAttendeeId;
    if (!attendeeId) {
      return;
    }
    (0, _logger.sendToDatadog)(_constants.loggerName, _objectSpread(_objectSpread({}, tileState), {}, {
      'attendee-id': attendeeId
    }));
    var setPresence = (0, _getAttendeePresenceFunc.getAttendeePresenceFunc)(dispatch, {
      disconnectSource: disconnectSource,
      setAttendeePresence: setAttendeePresence
    }, attendeeId);
    setPresence(attendeeId, true);
    subscribeToVolumeIndicatorOnce(dispatch, setAttendeeMuteStatus, meetingSession, attendeeId, setAttendeeVoiceIntensity);
    dispatch(setAttendeeTile(tileState));
    if (!tileState.isContent && tileState.localTile) {
      dispatch(setMeetingDirectorValue(tileState.boundAttendeeId));
    }
  };
}
function videoTileDidUpdateHandlerForSpeaker(dispatch, actions, meetingSession) {
  return function videoTileDidUpdateHandler(tileState) {
    var setAttendeeTile = actions.setAttendeeTile,
      persistAttendeeId = actions.persistAttendeeId,
      setAttendeeCameraStatus = actions.setAttendeeCameraStatus,
      setAttendeesCameraStatus = actions.setAttendeesCameraStatus,
      setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity;
    // Ignore a tile without attendee ID and other attendee's tile.
    if (!tileState.boundAttendeeId) {
      return;
    }

    //Note: you can access tileState.isContent to determine if it's a screen share, or a non-camera source
    dispatch(setAttendeeTile(tileState));
    // Persist for local attendee
    if (tileState.localTile) {
      dispatch(persistAttendeeId(tileState.boundAttendeeId));
    }
    // Only set camera status for tiles which is not the local tile, and it's not a screenshare tile
    if (!tileState.localTile && !tileState.boundAttendeeId.includes('#content')) {
      var isAttendeeCameraOn = meetingSession.audioVideo.videoTileController.haveVideoTileForAttendeeId(tileState.boundAttendeeId);
      var payload = _defineProperty({}, tileState.boundAttendeeId, isAttendeeCameraOn);

      // TODO: Fix this irregular action handlers
      dispatch(setAttendeeCameraStatus(tileState.boundAttendeeId, isAttendeeCameraOn));
      dispatch(setAttendeesCameraStatus(payload));
    }
    if (!!setAttendeeVoiceIntensity) {
      subscribeToVolumeIndicatorOnce(dispatch, null, meetingSession, tileState.boundAttendeeId, setAttendeeVoiceIntensity);
    }
  };
}
function videoTileDidUpdateHandlerForMixer(dispatch, setAttendeeTile, setAttendeeCameraStatus, attendeeCameraStatusHandler, meetingSession) {
  return function videoTileDidUpdateHandler(tileState) {
    // Ignore a tile without attendee ID and other attendee's tile.
    if (!tileState.boundAttendeeId) return;
    (0, _logger.sendToDatadog)(_constants.loggerName, _objectSpread(_objectSpread({}, tileState), {}, {
      'attendee-id': tileState.boundAttendeeId
    }), 'Chime - VideoTileDidUpdate Event');
    dispatch(setAttendeeTile(tileState));
    if (!tileState.boundAttendeeId.includes('#content')) {
      attendeeCameraStatusHandler(meetingSession, dispatch, setAttendeeCameraStatus);
    }
  };
}